import BookingMessageActions from "./BookingMessageActions";
import { MessageEvent } from "../BookingMessageTypes";
import { Language } from "../../../language/English";

interface BookingMessageItemProps {
    event: MessageEvent;
    highlighted: boolean;
    hideSeeAllMessage?: boolean;
    formatDateTime: (value: number | string | null) => string;
    onSeeAllMessage: (event: MessageEvent) => void;
    getBusinessEditLink: (businessId: number | null) => string;
    getBusinessPublicProfileLink: (businessUrl: string | null, businessId: number | null) => string;
    getBookingDetailsLink: (bookingId: number | null) => string;
    getBusinessBookingsLink: (businessId: number | null) => string;
    openActionId: string | null;
    setOpenActionId: (id: string | null) => void;
}

const BookingMessageItem = ({
    event,
    highlighted,
    hideSeeAllMessage = false,
    formatDateTime,
    onSeeAllMessage,
    getBusinessEditLink,
    getBusinessPublicProfileLink,
    getBookingDetailsLink,
    getBusinessBookingsLink,
    openActionId,
    setOpenActionId,
}: BookingMessageItemProps) => {
    return (
        <div key={event.id} data-event-id={event.id} className={`booking-message-row ${event.direction}`}>
            <div className={`booking-message-item ${event.direction} ${highlighted ? "is-highlighted" : ""}`}>
                <div className="booking-message-direction-label">
                    {event.direction === "outward" ? Language.SENT_BOOKING_MESSAGE : `${Language.REPLY_FROM} ${event.phoneNumber}`}
                </div>
                <p>{event.text}</p>
                {event.direction === "outward" && event.details && event.details.length > 0 ? (
                    <div className="booking-outward-details">
                        {event.details.map((detail) => (
                            <div key={`${event.id}-${detail.label}`}>
                                <strong>{detail.label}:</strong> {detail.value}
                            </div>
                        ))}
                    </div>
                ) : null}
                <time>{formatDateTime(event.createdOn)}</time>

                <BookingMessageActions
                    event={event}
                    onSeeAllMessage={onSeeAllMessage}
                    hideSeeAllMessage={hideSeeAllMessage}
                    getBusinessEditLink={getBusinessEditLink}
                    getBusinessPublicProfileLink={getBusinessPublicProfileLink}
                    getBookingDetailsLink={getBookingDetailsLink}
                    getBusinessBookingsLink={getBusinessBookingsLink}
                    openActionId={openActionId}
                    setOpenActionId={setOpenActionId}
                />
            </div>
        </div>
    );
};

export default BookingMessageItem;
